module.exports = __webpack_public_path__ + "static/media/feeling good.751f2f6f.jpg";